import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';

import pdfMake from "pdfmake/build/pdfmake.js";
import pdfFonts from 'pdfmake/build/vfs_fonts.js';
import { Subscription, interval, lastValueFrom } from 'rxjs';
import { estadoTiempo } from 'src/app/shared/const/estado-tiempo.enum';
import { pdf } from 'src/app/shared/const/pdf.enum';
import { sexo } from 'src/app/shared/const/sexo.enum';
import { LocalStorageService } from 'src/app/shared/storage';
import Swal from 'sweetalert2';
import { ReadFileService } from '../../../services/read-file.service';
declare var bootstrap: any;


@Component({
    selector: 'app-marcaje-administracion',
    templateUrl: './marcaje-administracion.component.html',
    styleUrls: ['./marcaje-administracion.component.scss']
})
export class MarcajeAdminitracionComponent implements OnInit, OnDestroy {

    public marcajes: any[] = [];
    public subscription: Subscription;
    public porcentaje = 0;

    public lugarCategoriasGeneral: any = {};
    public lugarGirosGeneral: any = {};
    public lugarDesafioGeneral: any = {};
    public activarLugarGiros = false;
    public activarLugarDesafio = false;
    public activarLugarCategoria = false;

    public fin = false;

    public tipoClasificacion = null;
    public tipoDisciplina = null;

    public cantidadMarcajeAdminitracionCat = null;
    public cantidadMarcajeAdminitracionDes = null;
    public cantidadMarcajeAdminitracionGiro = null;

    public cantidadDeportistasEnRuta = 0;

    public lugarCategorias: any = {};
    public desafiosPremiacion = [];

    public desafioImpresionPdf = [];
    public prefixPathResultados = '';

    public pestanaSeleccionada = 0;
    public configuracionRanking = null;

    @ViewChild('uploadBtnRanking', { static: false }) fileInputRanking: ElementRef;

    @ViewChild('filterInputDesafio') filterInputDesafio!: ElementRef;
    filterTermDesafio: string = '';
    filterTermCategoria: string = '';

    public clasificaciones = [];

    selectedDesafios: any[] = [];
    selectedCategorias: any[] = [];

    cantidadRanking = 3;

    constructor(
        private readFileService: ReadFileService,
        private localStorageAs: LocalStorageService,
        private datePipe: DatePipe,

    ) {
        pdfMake.vfs = pdfFonts.pdfMake.vfs;

    }

    ngOnInit(): void {

        if (localStorage.getItem('path')) {
            this.getMarcajes();
        } else {
            Swal.fire(
                'Uppps....!',
                'Falta configurar la ruta del archivo',
                'error'
            );
        }

        if (localStorage.getItem('tipo_clasificacion')) {
            this.tipoClasificacion = localStorage.getItem('tipo_clasificacion');
        } else {
            Swal.fire(
                'Uppps....!',
                'Falta configurar el tipo de clasificación',
                'error'
            );
        }

        if (localStorage.getItem('tipo_disciplina')) {
            this.tipoDisciplina = localStorage.getItem('tipo_disciplina');
        } else {
            Swal.fire(
                'Uppps....!',
                'Falta configurar el tipo de disciplina',
                'error'
            );
        }

        if (localStorage.getItem('cantidad_marcaje_administracion_cat')) {
            this.cantidadMarcajeAdminitracionCat = localStorage.getItem('cantidad_marcaje_administracion_cat');
        } else {
            Swal.fire(
                'Uppps....!',
                'Falta configurar la cantidad de marcaje x categoría en módulo administración',
                'error'
            );
        }

        if (localStorage.getItem('cantidad_marcaje_administracion_des')) {
            this.cantidadMarcajeAdminitracionDes = localStorage.getItem('cantidad_marcaje_administracion_des');
        } else {
            Swal.fire(
                'Uppps....!',
                'Falta configurar la cantidad de marcaje x desafío en módulo administración',
                'error'
            );
        }

        if (localStorage.getItem('cantidad_marcaje_administracion_giro')) {
            this.cantidadMarcajeAdminitracionGiro = localStorage.getItem('cantidad_marcaje_administracion_giro');
        } else {
            Swal.fire(
                'Uppps....!',
                'Falta configurar la cantidad de marcaje por giro en módulo administración',
                'error'
            );
        }

        if (localStorage.getItem('configuracion_ranking')) {
            try {
                this.configuracionRanking = JSON.parse(localStorage.getItem('configuracion_ranking'));
            } catch (e) {
                this.configuracionRanking = null;
            }

        }

        this.cargarMarcarEnRuta();

        this.localStorageAs.watch('desafios_premiacion').subscribe(desafiosPremiacionStorage => {
            if (desafiosPremiacionStorage !== null) {
                this.desafiosPremiacion = JSON.parse(desafiosPremiacionStorage);

            }
        });


    }

     get DNF(): string {
        return estadoTiempo.DNF;
    };

    get DNS(): string {
        return  estadoTiempo.DNS;
    }

    get DPP(): string {
        return estadoTiempo.DPP;
    }

    cargarMarcarEnRuta() {
        if (localStorage.getItem('marcaje_adm_mostrar_en_ruta')) {
            this.cantidadDeportistasEnRuta = Number(localStorage.getItem('marcaje_adm_mostrar_en_ruta'));
        } else {
            Swal.fire(
                'Uppps....!',
                'Falta configurar la cantidad de deportistas a mostrar en ruta en módulo administración',
                'error'
            );
        }
    }

    getMarcajes() {
        const source = interval(1000);
        this.subscription = source.subscribe(async val => {
            this.porcentaje = (val % 5) * 20;

            if (val % 5 === 0) {

                const filesResultados = [];
                const resultados = await lastValueFrom(this.readFileService.getDirectory(localStorage.getItem('path')));
                const respuestaResultados = resultados.match(/\b\w*resultados\w*\b/g);
                respuestaResultados.forEach((file) => {
                    filesResultados.push(Number((file
                        .replace(/"/gi, '')
                        .replace(/lOG_resultados/gi, '')
                        .split('.txt')[0]))
                    );
                });
                this.prefixPathResultados = String(Math.max(...filesResultados));
                this.fin = true;
                this.getResultados();

            }


        });
    }


    async getResultados() {
        const resultados = await lastValueFrom(this.readFileService.getFile(`${localStorage.getItem('path')}/lOG_resultados${this.prefixPathResultados}.txt`));
        this.procesarResultados(resultados)
    }

    keyCantidadGiros() {
        return Object.keys(this.lugarGirosGeneral);
    }

    keyCantidadDesafio() {
        return Object.keys(this.lugarDesafioGeneral);
    }

    arrayCantidadGiros(key, sexo: string) {
        const deportistasListos = this.lugarGirosGeneral[key].filter(filtro => filtro.estadoTiempo !== this.DNF && filtro.estadoTiempo !== this.DNS && filtro.estadoTiempo !== this.DPP  && filtro.giros == filtro.girosCompletados && filtro.sexo.toString().toLowerCase() === sexo.toString().toLowerCase()).slice(0, this.cantidadMarcajeAdminitracionGiro);
        const deportistasEnRuta = this.lugarGirosGeneral[key].filter(filtro => filtro.estadoTiempo !== this.DNF && filtro.estadoTiempo !== this.DNS && filtro.estadoTiempo !== this.DPP && filtro.giros != filtro.girosCompletados && filtro.sexo.toString().toLowerCase() === sexo.toString().toLowerCase()).slice(0, this.cantidadDeportistasEnRuta);
        const deportistasEnRutaOrdenados = deportistasEnRuta.sort((a, b) => (a.tiempo < b.tiempo) ? -1 : 1);

        return deportistasListos.concat(deportistasEnRutaOrdenados);
    }

    arrayCantidadGirosImprimir(key, sexo: string) {
        return this.lugarGirosGeneral[key].filter(filtro => filtro.estadoTiempo !== this.DNF && filtro.estadoTiempo !== this.DNS && filtro.giros == filtro.girosCompletados && filtro.sexo.toString().toLowerCase() === sexo.toString().toLowerCase()).slice(0, this.cantidadMarcajeAdminitracionGiro);
    }

    arrayDesafio(key, sexo: string) {
        const deportistasListos = this.lugarDesafioGeneral[key].filter(filtro => filtro.estadoTiempo !== this.DNF && filtro.estadoTiempo !== this.DNS && filtro.estadoTiempo !== this.DPP  && filtro.giros == filtro.girosCompletados && filtro.sexo.toString().toLowerCase() === sexo.toString().toLowerCase()).slice(0, this.cantidadMarcajeAdminitracionDes);
        const deportistasEnRuta = this.lugarDesafioGeneral[key].filter(filtro => filtro.estadoTiempo !== this.DNF && filtro.estadoTiempo !== this.DNS && filtro.estadoTiempo !== this.DPP && filtro.giros != filtro.girosCompletados && filtro.sexo.toString().toLowerCase() === sexo.toString().toLowerCase()).slice(0, this.cantidadDeportistasEnRuta);
        const deportistasEnRutaOrdenados = deportistasEnRuta.sort((a, b) => (a.tiempo < b.tiempo) ? -1 : 1);

        return deportistasListos.concat(deportistasEnRutaOrdenados);
    }

    arrayDesafioImprimir(key, sexo: string) {
        return this.lugarDesafioGeneral[key].filter(filtro => filtro.estadoTiempo !== this.DNF && filtro.estadoTiempo !== this.DNS && filtro.estadoTiempo !== this.DPP  && filtro.giros == filtro.girosCompletados && filtro.sexo.toString().toLowerCase() === sexo.toString().toLowerCase()).slice(0, this.cantidadMarcajeAdminitracionDes);
    }

    keyCantidadCategorias() {
        return Object.keys(this.lugarCategoriasGeneral).sort();
    }

    arrayCantidadCategorias(key) {
        const deportistasListos = this.lugarCategoriasGeneral[key].filter(filtro => this.getMarcajePorDor(filtro.dor).posicion_categoria !== 'PREMIADO/A EN GENERAL' && filtro.estadoTiempo !== this.DNF && filtro.estadoTiempo !== this.DNS && filtro.estadoTiempo !== this.DPP  && filtro.giros == filtro.girosCompletados).slice(0, this.cantidadMarcajeAdminitracionCat);
        let deportistasEnRuta = this.lugarCategoriasGeneral[key].filter(filtro => this.getMarcajePorDor(filtro.dor).posicion_categoria !== 'PREMIADO/A EN GENERAL' && filtro.estadoTiempo !== this.DNF && filtro.estadoTiempo !== this.DNS && filtro.estadoTiempo !== this.DPP  && filtro.giros != filtro.girosCompletados).slice(0, this.cantidadDeportistasEnRuta);
        const deportistasEnRutaOrdenados = deportistasEnRuta.sort((a, b) => (a.tiempo < b.tiempo) ? -1 : 1);
        return deportistasListos.concat(deportistasEnRutaOrdenados);
    }

    arrayCantidadCategoriasImprimir(key) {
        return this.lugarCategoriasGeneral[key].filter(filtro => this.getMarcajePorDor(filtro.dor).posicion_categoria !== 'PREMIADO/A EN GENERAL' && filtro.estadoTiempo !== this.DNF && filtro.estadoTiempo !== this.DNS && filtro.estadoTiempo !== this.DPP  && filtro.giros == filtro.girosCompletados).slice(0, this.cantidadMarcajeAdminitracionCat);
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }

    }

    procesarResultados(resultados: string) {
        if (resultados === undefined) { return; }

        let marcajesCopy = [];
        let marcajesOrdenados = [];
        const lugarGiros: any = {};
        const lugarDesafio: any = {};
        this.lugarCategorias = {};
        resultados.toString().split('\n').forEach((linea, index) => {

            if (index > 0 && linea.length > 1) {
                if (linea.split('\t')[0] !== '') {

                    const giros = linea.split('\t').slice(5, 20);
                    const girosCompletados = giros.filter((giro) => giro !== '').length;
                    marcajesCopy.push({
                        dor: linea.split('\t')[0],
                        nombre: linea.split('\t')[3],
                        apellido: linea.split('\t')[2],
                        tiempo: linea.split('\t')[22],
                        categoria: linea.split('\t')[4].split(' ').join('_'),
                        giros: linea.split('\t')[42],
                        girosCompletados,
                        estadoTiempo: `${linea.split('\t')[23]}`,
                        team: `${linea.split('\t')[25]}`,
                        desafio: `${linea.split('\t')[40]}`,
                        sexo: (linea.split('\t')[39]).toString().toLowerCase(),
                        tag: linea.split('\t')[1],
                        id: linea.split('\t')[24],
                        tiempos: giros,
                        rut: linea.split('\t')[33]

                    });

                    // DESAFIO EXISTE
                    const resultado = this.desafioImpresionPdf.find(objeto => objeto.desafio === `${linea.split('\t')[40]}`);


                    if (resultado) {
                        if (resultado.categorias.indexOf(linea.split('\t')[4].split(' ').join('_')) === -1) {
                            resultado.categorias.push(linea.split('\t')[4].split(' ').join('_'));
                        }
                    } else {
                        this.desafioImpresionPdf.push({ 'desafio': `${linea.split('\t')[40]}`, 'categorias': [] });
                    }


                }


            }
        });


        marcajesCopy.forEach((marcajeCopy) => {
            if (!this.lugarCategorias[marcajeCopy.categoria]) {
                this.lugarCategorias[marcajeCopy.categoria] = [];
            }

            this.lugarCategorias[marcajeCopy.categoria] = this.lugarCategorias[marcajeCopy.categoria].concat([{
                dor: marcajeCopy.dor,
                nombre: marcajeCopy.nombre,
                apellido: marcajeCopy.apellido,
                tiempo: marcajeCopy.tiempo,
                categoria: marcajeCopy.categoria,
                giros: marcajeCopy.giros,
                girosCompletados: marcajeCopy.girosCompletados,
                estadoTiempo: `${marcajeCopy.estadoTiempo}`,
                team: `${marcajeCopy.team}`,
                desafio: `${marcajeCopy.desafio}`,
                sexo: marcajeCopy.sexo.toLowerCase(),
            }]);


            if (!lugarGiros[marcajeCopy.giros]) {
                lugarGiros[marcajeCopy.giros] = [];
            }

            lugarGiros[marcajeCopy.giros] = lugarGiros[marcajeCopy.giros].concat([{
                dor: marcajeCopy.dor,
                nombre: marcajeCopy.nombre,
                apellido: marcajeCopy.apellido,
                tiempo: marcajeCopy.tiempo,
                categoria: marcajeCopy.categoria,
                giros: marcajeCopy.giros,
                girosCompletados: marcajeCopy.girosCompletados,
                estadoTiempo: `${marcajeCopy.estadoTiempo}`,
                desafio: `${marcajeCopy.desafio}`,
                team: `${marcajeCopy.team}`,
                sexo: marcajeCopy.sexo.toLowerCase(),

            }]);

            if (!lugarDesafio[marcajeCopy.desafio]) {
                lugarDesafio[marcajeCopy.desafio] = [];
            }

            lugarDesafio[marcajeCopy.desafio] = lugarDesafio[marcajeCopy.desafio].concat([{
                dor: marcajeCopy.dor,
                nombre: marcajeCopy.nombre,
                apellido: marcajeCopy.apellido,
                tiempo: marcajeCopy.tiempo,
                categoria: marcajeCopy.categoria,
                giros: marcajeCopy.giros,
                girosCompletados: marcajeCopy.girosCompletados,
                estadoTiempo: `${marcajeCopy.estadoTiempo}`,
                team: `${marcajeCopy.team}`,
                desafio: `${marcajeCopy.desafio}`,
                sexo: marcajeCopy.sexo.toLowerCase(),
            }]);
        });


        this.marcajes = marcajesCopy;

        marcajesOrdenados = this.marcajes.sort((a, b) => (a.tiempo < b.tiempo) ? -1 : 1);

        (Object.keys(lugarGiros) as (keyof typeof lugarGiros)[]).forEach((key, index) => {
            lugarGiros[key] = lugarGiros[key].sort((a, b) => (a.tiempo < b.tiempo) ? -1 : 1);
        });

        this.marcajes.forEach((marcajeFor) => {
            lugarGiros[marcajeFor.giros].filter((filtro) => filtro.estadoTiempo !== this.DNF && filtro.estadoTiempo !== this.DNS && filtro.estadoTiempo !== this.DPP  && filtro.giros == filtro.girosCompletados).forEach((marcajeCategoria, index) => {
                if (marcajeCategoria.dor === marcajeFor.dor) {
                    marcajeFor.posicion_giro = index + 1;
                }

            });

            // MASCULINO
            lugarGiros[marcajeFor.giros].filter((filtro) => filtro.sexo === sexo.MASCULINO && filtro.estadoTiempo !== this.DNF && filtro.estadoTiempo !== this.DNS && filtro.estadoTiempo !== this.DPP  && filtro.giros == filtro.girosCompletados).forEach((marcajeCategoria, index) => {
                if (marcajeCategoria.dor === marcajeFor.dor) {
                    marcajeFor.posicion_giro_sexo = index + 1;
                }
            });

            // FEMENINO
            lugarGiros[marcajeFor.giros].filter((filtro) => filtro.sexo === sexo.FEMENINO && filtro.estadoTiempo !== this.DNF && filtro.estadoTiempo !== this.DNS && filtro.estadoTiempo !== this.DPP  && filtro.giros == filtro.girosCompletados).forEach((marcajeCategoria, index) => {
                if (marcajeCategoria.dor === marcajeFor.dor) {
                    marcajeFor.posicion_giro_sexo = index + 1;
                }
            });

            lugarGiros[marcajeFor.giros].filter((filtro) => filtro.estadoTiempo === this.DNF || filtro.estadoTiempo === this.DNS ||  filtro.estadoTiempo === this.DPP  || filtro.giros !== filtro.girosCompletados).forEach((marcajeCategoria, index) => {
                if (marcajeCategoria.dor === marcajeFor.dor) {
                    switch (marcajeCategoria.estadoTiempo) {
                        case this.DNF:
                            marcajeFor.posicion_giro = this.DNF;
                            marcajeFor.posicion_giro_sexo = this.DNF;
                            break;
                        case this.DNS:
                            marcajeFor.posicion_giro = this.DNS;
                            marcajeFor.posicion_giro_sexo = this.DNS;
                            break;
                        case this.DPP:
                            marcajeFor.posicion_giro = this.DPP;
                            marcajeFor.posicion_giro_sexo = this.DPP;
                            break;
                        default:
                            if (marcajeCategoria.girosCompletados < marcajeCategoria.giros) {
                                marcajeFor.posicion_giro = 'GIROS INCOMPLETOS';
                                marcajeFor.posicion_giro_sexo = 'GIROS INCOMPLETOS';
                            }
                            break;

                    }
                }

            });
        });

        this.lugarGirosGeneral = lugarGiros;


        (Object.keys(lugarDesafio) as (keyof typeof lugarDesafio)[]).forEach((key, index) => {
            lugarDesafio[key] = lugarDesafio[key].sort((a, b) => (a.tiempo < b.tiempo) ? -1 : 1);
        });

        this.marcajes.forEach((marcajeFor) => {
            lugarDesafio[marcajeFor.desafio].filter((filtro) => filtro.estadoTiempo !== this.DNF && filtro.estadoTiempo !== this.DNS && filtro.estadoTiempo !== this.DPP  && filtro.giros == filtro.girosCompletados).forEach((marcajeCategoria, index) => {
                if (marcajeCategoria.dor === marcajeFor.dor) {
                    marcajeFor.posicion_desafio = index + 1;
                }

            });

            // MASCULINO
            lugarDesafio[marcajeFor.desafio].filter((filtro) => filtro.sexo === sexo.MASCULINO && filtro.estadoTiempo !== this.DNF && filtro.estadoTiempo !== this.DNS && filtro.estadoTiempo !== this.DPP  && filtro.giros == filtro.girosCompletados).forEach((marcajeCategoria, index) => {
                if (marcajeCategoria.dor === marcajeFor.dor) {
                    marcajeFor.posicion_desafio_sexo = index + 1;
                }

            });

            // FEMENINO
            lugarDesafio[marcajeFor.desafio].filter((filtro) => filtro.sexo === sexo.FEMENINO && filtro.estadoTiempo !== this.DNF && filtro.estadoTiempo !== this.DNS && filtro.estadoTiempo !== this.DPP && filtro.giros == filtro.girosCompletados).forEach((marcajeCategoria, index) => {
                if (marcajeCategoria.dor === marcajeFor.dor) {
                    marcajeFor.posicion_desafio_sexo = index + 1;
                }

            });

            lugarDesafio[marcajeFor.desafio].filter((filtro) => filtro.estadoTiempo === this.DNF || filtro.estadoTiempo === this.DNS || filtro.estadoTiempo === this.DPP || filtro.giros !== filtro.girosCompletados).forEach((marcajeCategoria, index) => {
                if (marcajeCategoria.dor === marcajeFor.dor) {
                    switch (marcajeCategoria.estadoTiempo) {
                        case this.DNF:
                            marcajeFor.posicion_desafio = this.DNF;
                            marcajeFor.posicion_desafio_sexo = this.DNF;
                            break;
                        case this.DNS:
                            marcajeFor.posicion_desafio = this.DNS;
                            marcajeFor.posicion_desafio_sexo = this.DNS;
                            break;
                        case this.DPP:
                            marcajeFor.posicion_desafio = this.DPP;
                            marcajeFor.posicion_desafio_sexo = this.DPP;
                            break;
                        default:
                            if (marcajeCategoria.girosCompletados < marcajeCategoria.giros) {
                                marcajeFor.posicion_desafio = 'GIROS INCOMPLETOS';
                                marcajeFor.posicion_desafio_sexo = 'GIROS INCOMPLETOS';
                            }
                            break;

                    }
                }

            });
        });

        this.lugarDesafioGeneral = lugarDesafio;

        (Object.keys(this.lugarCategorias) as (keyof typeof this.lugarCategorias)[]).forEach((key, index) => {
            this.lugarCategorias[key] = this.lugarCategorias[key].sort((a, b) => (a.tiempo < b.tiempo) ? -1 : 1);
        });

        switch (this.tipoDisciplina) {
            case 'Trail':
                this.marcajes.forEach((marcajeFor) => {

                    if (this.tipoClasificacion === 'Por Giro' &&

                        (marcajeFor.posicion_giro_sexo > 0 &&
                            marcajeFor.posicion_giro_sexo <= this.buscarDesafioPremiacion(marcajeFor.desafio))) {
                        marcajeFor.posicion_categoria = 'PREMIADO/A EN GENERAL';
                    }
                    if (this.tipoClasificacion === 'Por Desafio' && (marcajeFor.posicion_desafio_sexo > 0 && marcajeFor.posicion_desafio_sexo <= this.buscarDesafioPremiacion(marcajeFor.desafio))) {
                        marcajeFor.posicion_categoria = 'PREMIADO/A EN GENERAL';

                    }


                });

                this.marcajes.filter((marcajeFiltro) => !(this.tipoClasificacion === 'Por Giro' && (marcajeFiltro.posicion_desafio_sexo > 0 && marcajeFiltro.posicion_desafio_sexo <= this.buscarDesafioPremiacion(marcajeFiltro.desafio))) &&
                    !(this.tipoClasificacion === 'Por Desafio' && (marcajeFiltro.posicion_desafio_sexo > 0 && marcajeFiltro.posicion_desafio_sexo <= this.buscarDesafioPremiacion(marcajeFiltro.desafio)))
                ).forEach((marcajeFor) => {
                    this.lugarCategorias[marcajeFor.categoria.split(' ').join('_')].filter((filtro) => filtro.estadoTiempo !== this.DNF && filtro.estadoTiempo !== this.DNS  && filtro.estadoTiempo !== this.DPP && filtro.giros == filtro.girosCompletados).forEach((marcajeCategoria, index) => {
                        if (marcajeCategoria.dor === marcajeFor.dor) {
                            marcajeFor.posicion_categoria = index + 1;
                        }

                    });

                    this.lugarCategorias[marcajeFor.categoria.split(' ').join('_')].filter((filtro) => filtro.estadoTiempo === this.DNF || filtro.estadoTiempo === this.DNS ||  filtro.estadoTiempo === this.DPP || filtro.giros !== filtro.girosCompletados).forEach((marcajeCategoria, index) => {
                        if (marcajeCategoria.dor === marcajeFor.dor) {
                            switch (marcajeCategoria.estadoTiempo) {
                                case this.DNF:
                                    marcajeFor.posicion_categoria = this.DNF;
                                    break;
                                case this.DNS:
                                    marcajeFor.posicion_categoria = this.DNS;
                                    break;
                                case this.DPP:
                                    marcajeFor.posicion_categoria = this.DPP;
                                    break;
                                default:
                                    if (marcajeCategoria.girosCompletados < marcajeCategoria.giros) {
                                        marcajeFor.posicion_categoria = 'GIROS INCOMPLETOS';
                                    }
                                    break;

                            }

                        }

                    });
                });
                break;

            case 'Ciclismo':
                this.marcajes.forEach((marcajeFor) => {
                    this.lugarCategorias[marcajeFor.categoria.split(' ').join('_')].filter((filtro) => filtro.estadoTiempo !== this.DNF && filtro.estadoTiempo !== this.DNS &&  filtro.estadoTiempo !== this.DPP && filtro.giros == filtro.girosCompletados).forEach((marcajeCategoria, index) => {
                        if (marcajeCategoria.dor === marcajeFor.dor) {
                            marcajeFor.posicion_categoria = index + 1;
                            marcajeFor.puntos_ranking = this.obtenerPuntosRanking(marcajeFor.posicion_categoria, marcajeFor.estadoTiempo);
                        }

                    });

                    this.lugarCategorias[marcajeFor.categoria.split(' ').join('_')].filter((filtro) => filtro.estadoTiempo === this.DNF || filtro.estadoTiempo === this.DNS || filtro.estadoTiempo === this.DPP || filtro.giros !== filtro.girosCompletados).forEach((marcajeCategoria, index) => {
                        if (marcajeCategoria.dor === marcajeFor.dor) {
                            switch (marcajeCategoria.estadoTiempo) {
                                case this.DNF:
                                    marcajeFor.posicion_categoria = this.DNF;
                                    break;
                                case this.DNS:
                                    marcajeFor.posicion_categoria = this.DNS;
                                    break;
                                case this.DPP:
                                    marcajeFor.posicion_categoria = this.DPP;
                                    break;
                                default:
                                    if (marcajeCategoria.girosCompletados < marcajeCategoria.giros) {
                                        marcajeFor.posicion_categoria = 'GIROS INCOMPLETOS';
                                    }
                                    break;

                            }

                            marcajeFor.puntos_ranking = this.obtenerPuntosRanking(marcajeFor.posicion_categoria, marcajeFor.estadoTiempo);

                        }

                    });
                });
                break;
            case 'Motociclismo':
                this.marcajes.forEach((marcajeFor) => {
                    this.lugarCategorias[marcajeFor.categoria.split(' ').join('_')].filter((filtro) => filtro.estadoTiempo !== this.DNF && filtro.estadoTiempo !== this.DNS  &&  filtro.estadoTiempo !== this.DPP && filtro.giros == filtro.girosCompletados).forEach((marcajeCategoria, index) => {
                        if (marcajeCategoria.dor === marcajeFor.dor) {
                            marcajeFor.posicion_categoria = index + 1;
                        }

                    });

                    this.lugarCategorias[marcajeFor.categoria.split(' ').join('_')].filter((filtro) => filtro.estadoTiempo === this.DNF || filtro.estadoTiempo === this.DNS || filtro.estadoTiempo === this.DPP || filtro.giros !== filtro.girosCompletados).forEach((marcajeCategoria, index) => {
                        if (marcajeCategoria.dor === marcajeFor.dor) {
                            switch (marcajeCategoria.estadoTiempo) {
                                case this.DNF:
                                    marcajeFor.posicion_categoria = this.DNF;
                                    break;
                                case this.DNS:
                                    marcajeFor.posicion_categoria = this.DNS;
                                    break;
                                case this.DPP:
                                    marcajeFor.posicion_categoria = this.DPP;
                                    break;
                                default:
                                    if (marcajeCategoria.girosCompletados < marcajeCategoria.giros) {
                                        marcajeFor.posicion_categoria = 'GIROS INCOMPLETOS';
                                    }
                                    break;

                            }

                        }

                    });
                });
                break;
        }

        this.lugarCategoriasGeneral = this.lugarCategorias;

    }

    buscarDesafioPremiacion(desafio) {
        return this.desafiosPremiacion[desafio] === undefined ? 0 : this.desafiosPremiacion[desafio];
    }

    nombreEvento() {
        return localStorage.getItem('nombre_evento') ? localStorage.getItem('nombre_evento') : '';
    }

    imprimir(elem) {
        this.printElem(elem);
    }

    printElem(elem) {
        const mywindow = window.open('', 'PRINT',);

        mywindow.document.write('<html><head>');
        mywindow.document.write('</head><body >');
        // mywindow.document.write('<h1 style="text-align: center">' + document.title  + '</h1>');
        mywindow.document.write(document.getElementById(elem).innerHTML);
        mywindow.document.write('</body></html>');

        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/

        mywindow.print();
        mywindow.close();
        window.location.reload();

        return true;

    }

    getMarcajePorDor(dorsal: string) {
        return this.marcajes.find((marcaje) => marcaje.dor === dorsal);
    }


    getGirosIncompletos(categoria) {
        let girosIncompletos = 0;

        if (this.lugarCategorias[categoria] === undefined) {
            return 0;
        }

        this.lugarCategorias[categoria].forEach((lugarCategoria) => {
            if (lugarCategoria.girosCompletados < lugarCategoria.giros && lugarCategoria.estadoTiempo !== this.DNF && lugarCategoria.estadoTiempo !== this.DNS  && lugarCategoria.estadoTiempo !== this.DPP) {
                girosIncompletos = girosIncompletos + 1;
            }
        });


        return girosIncompletos;
    }

    getGirosIncompletosPorGiro(giro) {
        let girosIncompletos = 0;

        if (this.lugarGirosGeneral[giro] === undefined) {
            return 0;
        }

        this.lugarGirosGeneral[giro].forEach((lugarGiro) => {
            if (lugarGiro.girosCompletados < lugarGiro.giros && lugarGiro.estadoTiempo !== this.DNF && lugarGiro.estadoTiempo !== this.DNS && lugarGiro.estadoTiempo !== this.DPP) {
                girosIncompletos = girosIncompletos + 1;
            }
        });


        return girosIncompletos;
    }

    getGirosIncompletosPorGiroYSexo(giro, sexo) {
        let girosIncompletos = 0;

        if (this.lugarGirosGeneral[giro] === undefined) {
            return 0;
        }

        this.lugarGirosGeneral[giro].forEach((lugarGiro) => {
            if (lugarGiro.girosCompletados < lugarGiro.giros && lugarGiro.estadoTiempo !== this.DNF && lugarGiro.estadoTiempo !== this.DNS && lugarGiro.estadoTiempo !== this.DPP  && lugarGiro.sexo.toLowerCase() === sexo.toLowerCase()) {
                girosIncompletos = girosIncompletos + 1;
            }
        });


        return girosIncompletos;
    }

    getGirosIncompletosPorDesafio(desafio) {
        let girosIncompletos = 0;

        if (this.lugarDesafioGeneral[desafio] === undefined) {
            return 0;
        }

        this.lugarDesafioGeneral[desafio].forEach((lugarDesafio) => {
            if (lugarDesafio.girosCompletados < lugarDesafio.giros && lugarDesafio.estadoTiempo !== this.DNF && lugarDesafio.estadoTiempo !== this.DNS && lugarDesafio.estadoTiempo !== this.DPP) {
                girosIncompletos = girosIncompletos + 1;
            }
        });


        return girosIncompletos;
    }

    getGirosIncompletosPorDesafioYSexo(desafio, sexo) {
        let girosIncompletos = 0;

        if (this.lugarDesafioGeneral[desafio] === undefined) {
            return 0;
        }

        this.lugarDesafioGeneral[desafio].forEach((lugarDesafio) => {
            if (lugarDesafio.girosCompletados < lugarDesafio.giros && lugarDesafio.estadoTiempo !== this.DNF && lugarDesafio.estadoTiempo !== this.DNS && lugarDesafio.estadoTiempo !== this.DPP  && lugarDesafio.sexo.toLowerCase() === sexo.toLowerCase()) {
                girosIncompletos = girosIncompletos + 1;
            }
        });


        return girosIncompletos;
    }

    formatearNombre(nombre: string, replaceFirst: boolean) {
        let nombreReturn = nombre.split('_').join(' ');
        if (replaceFirst) {
            const partes = nombreReturn.split(" ");
            partes.shift();
            nombreReturn = partes.join(" ");
            return nombreReturn;
        } else {
            return nombreReturn;
        }

    }
    generarPdfMakeGiros() {
        this.clasificaciones = this.obtenerClasificacionGiro();

        const contenido: any = [{
            columns: [
                {
                    width: '20%',
                    image: pdf.LOGO_BASE64,
                    fit: [100, 100],
                    margin: [0, 0, 0, 10]
                },
                {
                    width: '60%',
                    text: [
                        { text: 'Clasificación de deportistas\n', fontSize: 16, bold: true, alignment: 'center' },
                        { text: `${this.nombreEvento()}\n`, fontSize: 12, alignment: 'center' },
                        { text: `Generado el ${this.formatDate()}`, fontSize: 12, alignment: 'center' }

                    ],
                    margin: [0, 0, 0, 10]
                },
                {
                    width: '20%',
                    text: ''
                }
            ],
            columnGap: 10
        },

        ];


        this.clasificaciones.forEach((clasificacion, indice) => {
            contenido.push(
                {
                    text: `${clasificacion.nombre}`,
                    alignment: 'center',
                    style: 'desafioStyle'
                });


            clasificacion.categorias.forEach(categoria => {
                const corredores: any = [
                    [{ text: categoria.nombre, style: 'tableHeader', colSpan: 5, alignment: 'center', }, {}, {}, {}, {}],
                    [{ text: ' ', style: 'tableHeader', colSpan: 5, alignment: 'center' }, {}, {}, {}, {}],
                    [{ text: 'Pos. #', alignment: 'center' }, { text: 'Deportista', alignment: 'center' }, { text: 'Team', alignment: 'center', }, { text: 'DOR', alignment: 'center', }, { text: 'Tiempo', alignment: 'center' }],
                ];
                categoria.corredores.forEach(corredor => {
                    corredores.push([{ text: corredor.posicion, alignment: 'center', fontSize: 10 }, { text: corredor.nombre, alignment: 'center', fontSize: 10 }, { text: corredor.team, alignment: 'center', fontSize: 10 }, { text: corredor.dor, alignment: 'center', fontSize: 10 }, { text: corredor.tiempo, alignment: 'center', fontSize: 10 }]);

                });

                contenido.push({
                    style: 'tableExample',
                    table: {
                        headerRows: 2,
                        widths: ['*', '*', '*', '*', '*'],
                        body: corredores,

                    },
                    layout: {
                        fillColor: function (rowIndex, node, columnIndex) {
                            return (rowIndex === 0) ? '#ffbf01' : null;
                        },
                        hLineWidth: function (i, node) {
                            // Solo dibuja una línea horizontal en la última fila
                            return (i > 2) ? 1 : 0;
                        },
                        hLineColor: function (i, node) {
                            // Color de la línea horizontal en la última fila
                            return (i > 3) ? '#cecece' : null;
                        },
                        vLineWidth: function (i, node) {
                            // No dibuja líneas verticales
                            return 0;
                        },
                        paddingLeft: function (i, node) { return 4; },
                        paddingRight: function (i, node) { return 4; },
                        paddingTop: function (i, node) { return 2; },
                        paddingBottom: function (i, node) {
                            return i === 2 ? 10 : 7;
                        },

                    }
                });
            });


            if (indice !== this.clasificaciones.length - 1) {
                contenido.push({ text: '', pageBreak: 'after' });
            }


        });


        const pdfDefinition: any = {
            header: [],
            content: contenido,
            footer: (currentPage, pageCount, pageSize) => {
                return {
                    text: `Esta clasificación fue generada de forma automática por el Sistema de Cronometraje Bikerace ®.`,
                    alignment: 'center',
                    margin: [0, 10],
                    style: 'footerStyle'
                };
            },
            styles: {
                footerStyle: {
                    color: '#cecece', // Cambia el color del texto aquí
                    fontSize: 10,
                    margin: [0, 10]
                },
                desafioStyle: {
                    // color: 'white', // Cambia el color del texto aquí
                    fontSize: 16,
                    color: 'black',
                    decoration: 'underline',
                    margin: [0, 10],

                },
                header: {
                    fontSize: 18,
                    bold: true,
                    margin: [0, 0, 0, 10]
                },
                subheader: {
                    fontSize: 16,
                    bold: true,
                    margin: [0, 10, 0, 5]
                },
                tableExample: {
                    fontSize: 12,
                    margin: [0, 5, 0, 15]
                },
                tableHeader: {
                    bold: true,
                    fontSize: 13,
                    color: 'black'
                }
            },
            defaultStyle: {
                // alignment: 'justify'
            }

        };

        const pdfView = pdfMake.createPdf(pdfDefinition);
        pdfView.open();
    }

    generarPdfMakeDesafios() {

        const contenido: any = [{
            columns: [
                {
                    width: '20%',
                    image: pdf.LOGO_BASE64,
                    fit: [100, 100], // Ajusta el tamaño según sea necesario
                    margin: [0, 0, 0, 10] // Espaciado opcional alrededor del logo
                },
                {
                    width: '60%',
                    text: [
                        { text: 'Clasificación de deportistas\n', fontSize: 16, bold: true, alignment: 'center' },
                        { text: `${this.nombreEvento()}\n`, fontSize: 12, alignment: 'center' },
                        { text: `Generado el ${this.formatDate()}`, fontSize: 12, alignment: 'center' }

                    ],
                    margin: [0, 0, 0, 10] // Espaciado opcional alrededor del texto
                },
                {
                    width: '20%',
                    text: '' // Espacio vacío para alinear el contenido
                }
            ],
            columnGap: 10 // Espacio entre columnas
        },

        ];


        this.selectedDesafios.forEach((clasificacion, indice) => {
            contenido.push(
                {
                    text: `${clasificacion.nombre}`,
                    alignment: 'center',
                    style: 'desafioStyle'
                });


            clasificacion.categorias.forEach(categoria => {
                const corredores: any = [
                    [{ text: categoria.nombre, style: 'tableHeader', colSpan: 5, alignment: 'center', }, {}, {}, {}, {}],
                    [{ text: ' ', style: 'tableHeader', colSpan: 5, alignment: 'center' }, {}, {}, {}, {}],
                    [{ text: 'Pos. #', alignment: 'center' }, { text: 'Deportista', alignment: 'center' }, { text: 'Team', alignment: 'center', }, { text: 'DOR', alignment: 'center', }, { text: 'Tiempo', alignment: 'center' }],
                ];
                categoria.corredores.forEach(corredor => {
                    corredores.push([{ text: corredor.posicion, alignment: 'center', fontSize: 10 }, { text: corredor.nombre, alignment: 'center', fontSize: 10 }, { text: corredor.team, alignment: 'center', fontSize: 10 }, { text: corredor.dor, alignment: 'center', fontSize: 10 }, { text: corredor.tiempo, alignment: 'center', fontSize: 10 }]);

                });

                contenido.push({
                    style: 'tableExample',
                    table: {
                        headerRows: 2,
                        widths: ['*', '*', '*', '*', '*'],
                        body: corredores,

                    },
                    layout: {
                        fillColor: function (rowIndex, node, columnIndex) {
                            return (rowIndex === 0) ? '#ffbf01' : null;
                        },
                        hLineWidth: function (i, node) {
                            // Solo dibuja una línea horizontal en la última fila
                            return (i > 2) ? 1 : 0;
                        },
                        hLineColor: function (i, node) {
                            // Color de la línea horizontal en la última fila
                            return (i > 3) ? '#cecece' : null;
                        },
                        vLineWidth: function (i, node) {
                            // No dibuja líneas verticales
                            return 0;
                        },
                        paddingLeft: function (i, node) { return 4; },
                        paddingRight: function (i, node) { return 4; },
                        paddingTop: function (i, node) { return 2; },
                        paddingBottom: function (i, node) {
                            return i === 2 ? 10 : 7;
                        },

                    }
                });
            });



            if (indice !== this.selectedDesafios.length - 1) {
                contenido.push({ text: '', pageBreak: 'after' });
            }

        });


        const pdfDefinition: any = {
            header: [],
            content: contenido,
            footer: (currentPage, pageCount, pageSize) => {
                return {
                    text: `Esta clasificación fue generada de forma automática por el Sistema de Cronometraje Bikerace ®.`,
                    alignment: 'center',
                    margin: [0, 10],
                    style: 'footerStyle'
                };
            },
            styles: {
                footerStyle: {
                    color: '#cecece', // Cambia el color del texto aquí
                    fontSize: 10,
                    margin: [0, 10]
                },
                desafioStyle: {
                    fontSize: 16,
                    color: 'black',
                    decoration: 'underline',
                    margin: [0, 10],

                },
                header: {
                    fontSize: 18,
                    bold: true,
                    margin: [0, 0, 0, 10]
                },
                subheader: {
                    fontSize: 16,
                    bold: true,
                    margin: [0, 10, 0, 5]
                },
                tableExample: {
                    margin: [0, 5, 0, 15]
                },
                tableHeader: {
                    bold: true,
                    fontSize: 13,
                    color: 'black'
                }
            },
            defaultStyle: {
                // alignment: 'justify'
            }

        };

        const pdfView = pdfMake.createPdf(pdfDefinition);
        pdfView.open();
    }

    generarPdfMakeCategorias() {
        const clasificacionCategoria = this.obtenerClasificacionCategoria();

        const contenido: any = [{
            columns: [
                {
                    width: '20%',
                    image: pdf.LOGO_BASE64,
                    fit: [100, 100], // Ajusta el tamaño según sea necesario
                    margin: [0, 0, 0, 10] // Espaciado opcional alrededor del logo
                },
                {
                    width: '60%',
                    text: [
                        { text: 'Clasificación de deportistas\n', fontSize: 16, bold: true, alignment: 'center' },
                        { text: `${this.nombreEvento()}\n`, fontSize: 12, alignment: 'center' },
                        { text: `Generado el ${this.formatDate()}`, fontSize: 12, alignment: 'center' }

                    ],
                    margin: [0, 0, 0, 10] // Espaciado opcional alrededor del texto
                },
                {
                    width: '20%',
                    text: '' // Espacio vacío para alinear el contenido
                }
            ],
            columnGap: 10 // Espacio entre columnas
        },

        ];


        const desafiosConCategorias = clasificacionCategoria
            .filter(desafio => {
                return desafio.categorias.some(categoria =>
                    this.selectedCategorias.some(clasificacion =>
                        clasificacion.nombreCategoria === categoria.nombre && clasificacion.nombreDesafio === desafio.nombre
                    )
                );
            })
            .map(desafio => {
                const categoriasFiltradas = desafio.categorias.filter(categoria =>
                    this.selectedCategorias.some(clasificacion =>
                        clasificacion.nombreCategoria === categoria.nombre && clasificacion.nombreDesafio === desafio.nombre
                    )
                );

                return {
                    ...desafio,
                    categorias: categoriasFiltradas
                };
            });


        desafiosConCategorias.forEach((clasificacion, indice) => {

            contenido.push(
                {
                    text: `${clasificacion.nombre}`,
                    alignment: 'center',
                    style: 'desafioStyle'
                });


            clasificacion.categorias.forEach(categoria => {
                const corredores: any = [
                    [{ text: categoria.nombre, style: 'tableHeader', colSpan: 5, alignment: 'center', }, {}, {}, {}, {}],
                    [{ text: ' ', style: 'tableHeader', colSpan: 5, alignment: 'center' }, {}, {}, {}, {}],
                    [{ text: 'Pos. #', alignment: 'center' }, { text: 'Deportista', alignment: 'center' }, { text: 'Team', alignment: 'center', }, { text: 'DOR', alignment: 'center', }, { text: 'Tiempo', alignment: 'center' }],
                ];
                categoria.corredores.forEach(corredor => {
                    corredores.push([{ text: corredor.posicion, alignment: 'center', fontSize: 10 }, { text: corredor.nombre, alignment: 'center', fontSize: 10 }, { text: corredor.team, alignment: 'center', fontSize: 10 }, { text: corredor.dor, alignment: 'center', fontSize: 10 }, { text: corredor.tiempo, alignment: 'center', fontSize: 10 }]);

                });

                contenido.push({
                    style: 'tableExample',
                    table: {
                        headerRows: 2,
                        widths: ['*', '*', '*', '*', '*'],
                        body: corredores,

                    },
                    layout: {
                        fillColor: function (rowIndex, node, columnIndex) {
                            return (rowIndex === 0) ? '#ffbf01' : null;
                        },
                        hLineWidth: function (i, node) {
                            // Solo dibuja una línea horizontal en la última fila
                            return (i > 2) ? 1 : 0;
                        },
                        hLineColor: function (i, node) {
                            // Color de la línea horizontal en la última fila
                            return (i > 3) ? '#cecece' : null;
                        },
                        vLineWidth: function (i, node) {
                            // No dibuja líneas verticales
                            return 0;
                        },
                        paddingLeft: function (i, node) { return 4; },
                        paddingRight: function (i, node) { return 4; },
                        paddingTop: function (i, node) { return 2; },
                        paddingBottom: function (i, node) {
                            return i === 2 ? 10 : 7;
                        },

                    }
                });
            });



            if (indice !== desafiosConCategorias.length - 1) {
                contenido.push({ text: '', pageBreak: 'after' });
            }

        });


        const pdfDefinition: any = {
            header: [],
            content: contenido,
            footer: (currentPage, pageCount, pageSize) => {
                return {
                    text: `Esta clasificación fue generada de forma automática por el Sistema de Cronometraje Bikerace ®.`,
                    alignment: 'center',
                    margin: [0, 10],
                    style: 'footerStyle'
                };
            },
            styles: {
                footerStyle: {
                    color: '#cecece', // Cambia el color del texto aquí
                    fontSize: 10,
                    margin: [0, 10]
                },
                desafioStyle: {
                    // color: 'white', // Cambia el color del texto aquí
                    fontSize: 16,
                    color: 'black',
                    decoration: 'underline',
                    margin: [0, 10],

                },
                header: {
                    fontSize: 18,
                    bold: true,
                    margin: [0, 0, 0, 10]
                },
                subheader: {
                    fontSize: 16,
                    bold: true,
                    margin: [0, 10, 0, 5]
                },
                tableExample: {
                    margin: [0, 5, 0, 15]
                },
                tableHeader: {
                    bold: true,
                    fontSize: 13,
                    color: 'black'
                }
            },
            defaultStyle: {
                // alignment: 'justify'
            }

        };

        const pdfView = pdfMake.createPdf(pdfDefinition);
        pdfView.open();

    }

    generarPdfMakeRanking(dataRanking: any, cantidadRanking: number) {
        const cantidadFechas = Number(dataRanking[0].cantidad_fechas);
        const contenido: any = [{
            columns: [
                {
                    width: '20%',
                    image: pdf.LOGO_BASE64,
                    fit: [100, 100],
                    margin: [0, 0, 0, 10]
                },
                {
                    width: '60%',
                    text: [
                        { text: 'Clasificación de deportistas\n', fontSize: 16, bold: true, alignment: 'center' },
                        // { text: `${this.nombreEvento()}\n`, fontSize: 12, alignment: 'center' },
                        { text: `Generado el ${this.formatDate()}`, fontSize: 12, alignment: 'center' }

                    ],
                    margin: [0, 0, 0, 10]
                },
                {
                    width: '20%',
                    text: ''
                }
            ],
            columnGap: 10
        }];

        dataRanking[0].categorias.forEach((categoria, indice) => {

            const headerCategoria: any = [{ text: `${categoria.nombre} ${categoria.sexo}`, style: 'tableHeader', colSpan: cantidadFechas + 3, alignment: 'center' }];
            const rowSpace: any = [{ text: ' ', style: 'tableHeader', colSpan: 5, alignment: 'center' }];
            for (let index = 1; index < cantidadFechas + 3; index++) {
                headerCategoria.push({});
                rowSpace.push({});

            }

            const headerDeportista: any = [{ text: 'Pos. #', alignment: 'center' }, { text: 'Deportista', alignment: 'center' }];
            for (let index = 1; index <= cantidadFechas; index++) {
                headerDeportista.push({ text: `Fecha ${index}`, alignment: 'center' });
            }
            headerDeportista.push({ text: `Puntaje Total`, alignment: 'center' });


            const corredores: any = [
                headerCategoria,
                rowSpace,
                headerDeportista,
            ];

            categoria.corredores
                .sort((a, b) => b.puntaje_total - a.puntaje_total) // orden descendente
                .slice(0, cantidadRanking)
                .forEach((corredor, indiceCorredor) => {
                    const corredorRow = [{ text: indiceCorredor + 1, alignment: 'center', fontSize: 10 }, { text: `${corredor.nombre} ${corredor.apellido}`, alignment: 'center', fontSize: 10 }];

                    for (let index = 1; index <= cantidadFechas; index++) {
                        corredorRow.push({ text: this.getPuntajeFecha(corredor.fechas, index), alignment: 'center', fontSize: 10 });
                    }

                    corredorRow.push({ text: corredor.puntaje_total, alignment: 'center', fontSize: 10 });
                    corredores.push(corredorRow);
                });


            const widths = [];
            for (let index = 1; index <= cantidadFechas + 3; index++) {
                widths.push('*');

            }
            contenido.push({
                style: 'tableExample',
                table: {
                    headerRows: 2,
                    widths: widths,
                    body: corredores,

                },
                layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                        return (rowIndex === 0) ? '#ffbf01' : null;
                    },
                    hLineWidth: function (i, node) {
                        return (i > 2) ? 1 : 0;
                    },
                    hLineColor: function (i, node) {
                        return (i > 3) ? '#cecece' : null;
                    },
                    vLineWidth: function (i, node) {
                        return 0;
                    },
                    paddingLeft: function (i, node) { return 4; },
                    paddingRight: function (i, node) { return 4; },
                    paddingTop: function (i, node) { return 2; },
                    paddingBottom: function (i, node) {
                        return i === 2 ? 10 : 7;
                    },

                }
            });

            if (indice !== dataRanking[0].categorias.length - 1) {
                contenido.push({ text: '', pageBreak: 'after' });
            }

        });


        const pdfDefinition: any = {
            pageOrientation: 'landscape',
            header: [],
            content: contenido,
            footer: (currentPage, pageCount, pageSize) => {
                return {
                    text: `Esta clasificación fue generada de forma automática por el Sistema de Cronometraje Bikerace ®.`,
                    alignment: 'center',
                    margin: [0, 10],
                    style: 'footerStyle'
                };
            },
            styles: {
                footerStyle: {
                    color: '#cecece',
                    fontSize: 10,
                    margin: [0, 10]
                },
                header: {
                    fontSize: 18,
                    bold: true,
                    margin: [0, 0, 0, 10]
                },
                subheader: {
                    fontSize: 16,
                    bold: true,
                    margin: [0, 10, 0, 5]
                },
                tableExample: {
                    margin: [0, 5, 0, 15]
                },
                tableHeader: {
                    bold: true,
                    fontSize: 13,
                    color: 'black'
                }
            }
        };

        const pdfView = pdfMake.createPdf(pdfDefinition);
        pdfView.open();

    }

    getPuntajeFecha(fechas: any, index: number) {
        return fechas.find((fecha) => fecha.nombre.split('-')[1].includes('Fecha ' + index)) === undefined ? '-'
            : fechas.find((fecha) => fecha.nombre.split('-')[1].includes('Fecha ' + index)).puntos;
    }

    downloadPDF(elementHtml: string) {
        let modalElement = null;
        let modal = null;
        switch (elementHtml) {
            case 'clasificacion-categoria':
                this.clasificaciones = this.obtenerCategorias();
                this.selectedCategorias = [];
                modalElement = document.getElementById('categoriasModal') as HTMLElement;
                modal = new bootstrap.Modal(modalElement);
                modal.show();
                break;
            case 'clasificacion-giro':
                this.generarPdfMakeGiros();
                break;
            case 'clasificacion-desafio':
                this.clasificaciones = this.obtenerClasificacionDesafio();
                this.selectedDesafios = [];
                modalElement = document.getElementById('desafiosModal') as HTMLElement;
                modal = new bootstrap.Modal(modalElement);
                modal.show();
                break;
        }

    }

    onCheckboxChangeDesafios(item: any) {
        if (item.selected) {
            this.selectedDesafios.push(item);
        } else {
            const index = this.selectedDesafios.findIndex(d => d.nombre === item.nombre);
            if (index !== -1) {
                this.selectedDesafios.splice(index, 1);
            }
        }

    }

    onCheckboxChangeCategorias(item: any) {
        if (item.selected) {
            this.selectedCategorias.push(item);
        } else {
            const index = this.selectedCategorias.findIndex(d => d.nombreCategoria === item.nombreCategoria && d.nombreDesafio === item.nombreDesafio);
            if (index !== -1) {
                this.selectedCategorias.splice(index, 1);
            }
        }
    }


    obtenerClasificacionCategoria() {
        const data = [];
        this.desafioImpresionPdf.forEach((desafioImpresionPdf) => {
            const categorias = [];
            desafioImpresionPdf.categorias.forEach((categoria) => {
                const corredores = [];
                this.arrayCantidadCategorias(categoria).forEach((corredor, index) => {
                    corredores.push({
                        'posicion': index + 1,
                        'nombre': `${corredor.nombre} ${corredor.apellido}`,
                        'team': corredor.team,
                        'dor': corredor.dor,
                        'tiempo': corredor.tiempo
                    });
                });

                categorias.push({
                    'nombre': this.formatearNombre(categoria, true),
                    'corredores': corredores,
                    'desafio': this.formatearNombre(desafioImpresionPdf.desafio, false)
                })
            });

            data.push({
                'nombre': this.formatearNombre(desafioImpresionPdf.desafio, false),
                'categorias': categorias
            })
        });

        return data;
    }

    obtenerCategorias() {
        const data = [];
        this.desafioImpresionPdf.forEach((desafioImpresionPdf) => {
            desafioImpresionPdf.categorias.forEach((categoria) => {
                data.push({
                    'nombreDesafio': this.formatearNombre(desafioImpresionPdf.desafio, false),
                    'nombreDesafioSinLimpiar': desafioImpresionPdf.desafio,
                    'nombreCategoria': this.formatearNombre(categoria, true),
                })
            });
        });

        return data;
    }

    obtenerClasificacionGiro() {
        const data = [];
        this.keyCantidadGiros().forEach((giro) => {
            const categorias = [];
            const corredoresMasculino = [];
            this.arrayCantidadGiros(giro, 'masculino').forEach((corredor, index) => {
                corredoresMasculino.push({
                    'posicion': index + 1,
                    'nombre': `${corredor.nombre} ${corredor.apellido}`,
                    'team': corredor.team,
                    'dor': corredor.dor,
                    'tiempo': corredor.tiempo
                });
            });

            categorias.push({
                'nombre': 'Masculino',
                'corredores': corredoresMasculino
            })

            const corredoresFemenino = [];
            this.arrayCantidadGiros(giro, 'femenino').forEach((corredor, index) => {
                corredoresFemenino.push({
                    'posicion': index + 1,
                    'nombre': `${corredor.nombre} ${corredor.apellido}`,
                    'team': corredor.team,
                    'dor': corredor.dor,
                    'tiempo': corredor.tiempo
                });
            });

            categorias.push({
                'nombre': 'Femenino',
                'corredores': corredoresFemenino
            })


            data.push({
                'nombre': `Cantidad Giros: ${giro}`,
                'categorias': categorias
            })
        });

        return data;
    }

    obtenerClasificacionDesafio() {
        const data = [];
        this.keyCantidadDesafio().forEach((desafio) => {
            const categorias = [];

            const corredoresMasculino = [];
            this.arrayDesafio(desafio, 'masculino').forEach((corredor, index) => {
                corredoresMasculino.push({
                    'posicion': index + 1,
                    'nombre': `${corredor.nombre} ${corredor.apellido}`,
                    'team': corredor.team,
                    'dor': corredor.dor,
                    'tiempo': corredor.tiempo
                });
            });

            categorias.push({
                'nombre': 'Masculino',
                'corredores': corredoresMasculino
            })

            const corredoresFemenino = [];
            this.arrayDesafio(desafio, 'femenino').forEach((corredor, index) => {
                corredoresFemenino.push({
                    'posicion': index + 1,
                    'nombre': `${corredor.nombre} ${corredor.apellido}`,
                    'team': corredor.team,
                    'dor': corredor.dor,
                    'tiempo': corredor.tiempo
                });
            });

            categorias.push({
                'nombre': 'Femenino',
                'corredores': corredoresFemenino
            })


            data.push({
                'nombre': `${this.formatearNombre(desafio, false)}`,
                'categorias': categorias
            })
        });

        return data;
    }

    public formatDate(): string {
        const currentDate = this.datePipe.transform(new Date(), 'dd/MM/yyyy HH:mm:ss');
        return currentDate;
    }

    esperar(ms: number): Promise<void> {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    marcajeEnRuta(marcajeEstadoTiempo: string) {
        return marcajeEstadoTiempo !== this.DNS && marcajeEstadoTiempo !== this.DNF && marcajeEstadoTiempo !== this.DPP;
    }

    cambioPestana(indice) {
        this.pestanaSeleccionada = indice;
    }

    exportarTiempoCronometraje() {
        const jsonString = JSON.stringify(this.marcajes, null, 2);
        const blob = new Blob([jsonString], { type: 'application/json' });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'resultados.json';
        a.click();
        window.URL.revokeObjectURL(url);
    }

    obtenerPuntosRanking(posicionCat: any, estadoT: string) {
        if (this.configuracionRanking === null) return 0;

        switch (estadoT) {
            case this.DNF:
                return this.configuracionRanking[this.DNF] ?? 0;
            case this.DNS:
                return this.configuracionRanking[this.DNS] ?? 0;
            case this.DPP:
                return this.configuracionRanking[this.DNS] ?? 0;    
        }

        if (posicionCat === "GIROS INCOMPLETOS") {
            return this.configuracionRanking["DEFECTO"] ?? 0;
        }

        return this.configuracionRanking[posicionCat] ?? this.configuracionRanking["DEFECTO"] ?? 0
    }

    importarRanking() {
        this.fileInputRanking.nativeElement.click()
    }

    leerRanking(event) {
    Swal.fire({
      title: 'Exportar Podio',
      text: '¿Cuántos deportistas quieres descargar en el Podio?',
      input: 'range',
      inputAttributes: {
        min: "1",
        max: "10",
        step: "1"
      },
      inputValue: '3',
      showCancelButton: false,
      confirmButtonText: 'Confirmar',

    }).then((result) => {
      if (result.isConfirmed) {
        this.cantidadRanking = result.value;

         const archivo = event.target.files[0];
        const lector = new FileReader();

        lector.onload = () => {
            try {
                const contenido = lector.result as string;
                const data = JSON.parse(contenido);
                const categoriasCampeonato = data[0].categorias;
                const marcajes = structuredClone(this.marcajes);
                marcajes.forEach((marcaje) => {
                    const categoriaId = Number(marcaje.categoria.split('_')[0]);
                    const categoriaCampeonato = categoriasCampeonato.find((categoria) => categoria.id === categoriaId);
                    if (categoriaCampeonato) {
                        const corredor = categoriaCampeonato.corredores.find((corredor) => corredor.rut === marcaje.rut);
                        if (corredor) {
                            corredor.fechas.push({
                                id: 0,
                                nombre: `${this.nombreEvento()} - Fecha ${data[0].cantidad_fechas}`,
                                puntos: Number(marcaje.puntos_ranking)
                            });
                            corredor.puntaje_total = corredor.puntaje_total + Number(marcaje.puntos_ranking ?? 0);
                        }
                    }
                });

                this.generarPdfMakeRanking(data, this.cantidadRanking);

            } catch (error) {
                console.error('Error al parsear JSON:', error);
            }
        };

        lector.readAsText(archivo);
      }
    });

  }

      
    

    filteredDataDesafios() {
        return this.clasificaciones.filter(item =>
            Object.values(item).some(value =>
                value.toString().toLowerCase().includes(this.filterTermDesafio.toLowerCase())
            )
        );
    }

    filteredDataCategorias() {
        return this.clasificaciones.filter(item =>
            Object.values(item).some(value =>
                value.toString().toLowerCase().includes(this.filterTermCategoria.toLowerCase())
            )
        );
    }

    imprimirDesafiosSeleccionados() {
        this.generarPdfMakeDesafios();
    }

    imprimirCategoriasSeleccionadas() {
        this.generarPdfMakeCategorias();
    }

    onRowCategoriaClick(item: any) {
        item.selected = !item.selected;
        this.onCheckboxChangeCategorias(item);
    }

    onRowDesafioClick(item: any) {
        item.selected = !item.selected;
        this.onCheckboxChangeDesafios(item);
    }

    toggleAllCategorias() {
        const isAll = this.isAllSelected();
        const items = this.filteredDataCategorias();

        items.forEach(item => {
            item.selected = !isAll;
            this.onCheckboxChangeCategorias(item);
        });
    }

    toggleAllDesafios() {
        const isAll = this.isAllDesafiosSelected();
        const items = this.filteredDataDesafios();

        items.forEach(item => {
            item.selected = !isAll;
            this.onCheckboxChangeDesafios(item);
        });
    }

    isAllSelected(): boolean {
        const items = this.filteredDataCategorias();
        if (items.length === 0) {
            return false;
        }
        return items.every(item => item.selected);
    }

    isAllDesafiosSelected(): boolean {
        const items = this.filteredDataDesafios();
        if (items.length === 0) {
            return false;
        }
        return items.every(item => item.selected);
    }
}
